import React, { Component } from "react";
import "./Home.css";

export default class Home extends Component {
    render() {
        return (
            <div className="Home">
                <div className="lander">
                    <h1>Scratch</h1>
                    <p>A starter web application</p>
                </div>
            </div>
        );
    }
}